export default "__VITE_ASSET__CVVzXr7M__"